export const jtfData = {
  num: {
    add: {
      left: [
        ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'],
        ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'],
        ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'],
        ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'],
        ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'],
        ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'],
        ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'],
        ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'],
        ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'],
        ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'],
      ],
      right: [
        ['0', '0', '0', '0', '0', '0', '0', '0', '0', '0'],
        ['1', '1', '1', '1', '1', '1', '1', '1', '1', '1'],
        ['2', '2', '2', '2', '2', '2', '2', '2', '2', '2'],
        ['3', '3', '3', '3', '3', '3', '3', '3', '3', '3'],
        ['4', '4', '4', '4', '4', '4', '4', '4', '4', '4'],
        ['5', '5', '5', '5', '5', '5', '5', '5', '5', '5'],
        ['6', '6', '6', '6', '6', '6', '6', '6', '6', '6'],
        ['7', '7', '7', '7', '7', '7', '7', '7', '7', '7'],
        ['8', '8', '8', '8', '8', '8', '8', '8', '8', '8'],
        ['9', '9', '9', '9', '9', '9', '9', '9', '9', '9'],
      ],
    },
    sub: {
      left: [
        ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'],
        ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10'],
        ['2', '3', '4', '5', '6', '7', '8', '9', '10', '11'],
        ['3', '4', '5', '6', '7', '8', '9', '10', '11', '12'],
        ['4', '5', '6', '7', '8', '9', '10', '11', '12', '13'],
        ['5', '6', '7', '8', '9', '10', '11', '12', '13', '14'],
        ['6', '7', '8', '9', '10', '11', '12', '13', '14', '15'],
        ['7', '8', '9', '10', '11', '12', '13', '14', '15', '16'],
        ['8', '9', '10', '11', '12', '13', '14', '15', '16', '17'],
        ['9', '10', '11', '12', '13', '14', '15', '16', '17', '18'],
      ],
      right: [
        ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'],
        ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'],
        ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'],
        ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'],
        ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'],
        ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'],
        ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'],
        ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'],
        ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'],
        ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'],
      ],
    },
    mul: {
      left: [
        ['0', '0', '0', '0', '0', '0', '0', '0', '0'],
        ['1', '1', '1', '1', '1', '1', '1', '1', '1', '1'],
        ['2', '2', '2', '2', '2', '2', '2', '2', '2', '2'],
        ['3', '3', '3', '3', '3', '3', '3', '3', '3', '3'],
        ['4', '4', '4', '4', '4', '4', '4', '4', '4', '4'],
        ['5', '5', '5', '5', '5', '5', '5', '5', '5', '5'],
        ['6', '6', '6', '6', '6', '6', '6', '6', '6', '6'],
        ['7', '7', '7', '7', '7', '7', '7', '7', '7', '7'],
        ['8', '8', '8', '8', '8', '8', '8', '8', '8', '8'],
        ['9', '9', '9', '9', '9', '9', '9', '9', '9', '9'],
      ],
      right: [
        ['1', '2', '3', '4', '5', '6', '7', '8', '9'],
        ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'],
        ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'],
        ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'],
        ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'],
        ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'],
        ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'],
        ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'],
        ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'],
        ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'],
      ],
    },
    div: {
      left: [
        ['0', '0', '0', '0', '0', '0', '0', '0', '0'],
        ['1', '2', '3', '4', '5', '6', '7', '8', '9'],
        ['2', '4', '6', '8', '10', '12', '14', '16', '18'],
        ['3', '6', '9', '12', '15', '18', '21', '24', '27'],
        ['4', '8', '12', '16', '20', '24', '28', '32', '36'],
        ['5', '10', '15', '20', '25', '30', '35', '40', '45'],
        ['6', '12', '18', '24', '30', '36', '42', '48', '54'],
        ['7', '14', '21', '28', '35', '42', '49', '56', '63'],
        ['8', '16', '24', '32', '40', '48', '56', '64', '72'],
        ['9', '18', '27', '36', '45', '54', '63', '72', '81'],
      ],
      right: [
        ['1', '2', '3', '4', '5', '6', '7', '8', '9'],
        ['1', '2', '3', '4', '5', '6', '7', '8', '9'],
        ['1', '2', '3', '4', '5', '6', '7', '8', '9'],
        ['1', '2', '3', '4', '5', '6', '7', '8', '9'],
        ['1', '2', '3', '4', '5', '6', '7', '8', '9'],
        ['1', '2', '3', '4', '5', '6', '7', '8', '9'],
        ['1', '2', '3', '4', '5', '6', '7', '8', '9'],
        ['1', '2', '3', '4', '5', '6', '7', '8', '9'],
        ['1', '2', '3', '4', '5', '6', '7', '8', '9'],
        ['1', '2', '3', '4', '5', '6', '7', '8', '9'],
      ],
    },
  },
  dec: {
    add: {
      left: [
        ['.1', '.2', '.25', '.3', '.4', '.5', '.6', '.7', '.8', '.9'],
        ['.1', '.2', '.25', '.3', '.4', '.5', '.6', '.7', '.8', '.9'],
        ['.1', '.2', '.25', '.3', '.4', '.5', '.6', '.7', '.8', '.9'],
        ['.1', '.2', '.25', '.3', '.4', '.5', '.6', '.7', '.8', '.9'],
        ['.1', '.2', '.25', '.3', '.4', '.5', '.6', '.7', '.8', '.9'],
        ['.1', '.2', '.25', '.3', '.4', '.5', '.6', '.7', '.8', '.9'],
        ['.1', '.2', '.25', '.3', '.4', '.5', '.6', '.7', '.8', '.9'],
        ['.1', '.2', '.25', '.3', '.4', '.5', '.6', '.7', '.8', '.9'],
        ['.1', '.2', '.25', '.3', '.4', '.5', '.6', '.7', '.8', '.9'],
        ['.1', '.2', '.25', '.3', '.4', '.5', '.6', '.7', '.8', '.9'],
      ],
      right: [
        ['.1', '.1', '.1', '.1', '.1', '.1', '.1', '.1', '.1', '.1'],
        ['.2', '.2', '.2', '.2', '.2', '.2', '.2', '.2', '.2', '.2'],
        ['.25', '.25', '.25', '.25', '.25', '.25', '.25', '.25', '.25', '.25'],
        ['.3', '.3', '.3', '.3', '.3', '.3', '.3', '.3', '.3', '.3'],
        ['.4', '.4', '.4', '.4', '.4', '.4', '.4', '.4', '.4', '.4'],
        ['.5', '.5', '.5', '.5', '.5', '.5', '.5', '.5', '.5', '.5'],
        ['.6', '.6', '.6', '.6', '.6', '.6', '.6', '.6', '.6', '.6'],
        ['.7', '.7', '.7', '.7', '.7', '.7', '.7', '.7', '.7', '.7'],
        ['.8', '.8', '.8', '.8', '.8', '.8', '.8', '.8', '.8', '.8'],
        ['.9', '.9', '.9', '.9', '.9', '.9', '.9', '.9', '.9', '.9'],
      ],
    },
    sub: {
      left: [
        ['.2', '.3', '.35', '.4', '.5', '.6', '.7', '.8', '.9', '1'],
        ['.3', '.4', '.45', '.5', '.6', '.7', '.8', '.9', '1', '1.1'],
        ['.35', '.45', '.5', '.55', '.65', '.75', '.85', '.95', '1.05', '1.15'],
        ['.4', '.5', '.55', '.6', '.7', '.8', '.9', '1', '1.1', '1.2'],
        ['.5', '.6', '.65', '.7', '.8', '.9', '1', '1.1', '1.2', '1.3'],
        ['.6', '.76', '.75', '.8', '.9', '1', '1.1', '1.2', '1.3', '1.4'],
        ['.7', '.8', '.85', '.9', '1', '1.1', '1.2', '1.3', '1.4', '1.5'],
        ['.8', '.9', '.95', '1', '1.1', '1.2', '1.3', '1.4', '1.5', '1.6'],
        ['.9', '1', '1.05', '1.1', '1.2', '1.3', '1.4', '1.5', '1.6', '1.7'],
        ['1', '1.1', '1.15', '1.2', '1.3', '1.4', '1.5', '1.6', '1.7', '1.8'],
      ],
      right: [
        ['.1', '.2', '.25', '.3', '.4', '.5', '.6', '.7', '.8', '.9'],
        ['.1', '.2', '.25', '.3', '.4', '.5', '.6', '.7', '.8', '.9'],
        ['.1', '.2', '.25', '.3', '.4', '.5', '.6', '.7', '.8', '.9'],
        ['.1', '.2', '.25', '.3', '.4', '.5', '.6', '.7', '.8', '.9'],
        ['.1', '.2', '.25', '.3', '.4', '.5', '.6', '.7', '.8', '.9'],
        ['.1', '.2', '.25', '.3', '.4', '.5', '.6', '.7', '.8', '.9'],
        ['.1', '.2', '.25', '.3', '.4', '.5', '.6', '.7', '.8', '.9'],
        ['.1', '.2', '.25', '.3', '.4', '.5', '.6', '.7', '.8', '.9'],
        ['.1', '.2', '.25', '.3', '.4', '.5', '.6', '.7', '.8', '.9'],
        ['.1', '.2', '.25', '.3', '.4', '.5', '.6', '.7', '.8', '.9'],
      ],
    },
    mul: {
      left: [
        ['.1', '.2', '.3', '.4', '.5', '.6', '.7', '.8', '.9', '1.5'],
        ['.1', '.2', '.3', '.4', '.5', '.6', '.7', '.8', '.9', '1.5'],
        ['.1', '.2', '.3', '.4', '.5', '.6', '.7', '.8', '.9', '1.5'],
        ['.1', '.2', '.3', '.4', '.5', '.6', '.7', '.8', '.9', '1.5'],
        ['.1', '.2', '.3', '.4', '.5', '.6', '.7', '.8', '.9', '1.5'],
        ['.1', '.2', '.3', '.4', '.5', '.6', '.7', '.8', '.9', '1.5'],
        ['.1', '.2', '.3', '.4', '.5', '.6', '.7', '.8', '.9', '1.5'],
        ['.1', '.2', '.3', '.4', '.5', '.6', '.7', '.8', '.9', '1.5'],
        ['.1', '.2', '.3', '.4', '.5', '.6', '.7', '.8', '.9', '1.5'],
        ['.1', '.2', '.3', '.4', '.5', '.6', '.7', '.8', '.9', '1.5'],
      ],
      right: [
        ['.1', '.1', '.1', '.1', '.1', '.1', '.1', '.1', '.1', '.1'],
        ['.2', '.2', '.2', '.2', '.2', '.2', '.2', '.2', '.2', '.2'],
        ['.3', '.3', '.3', '.3', '.3', '.3', '.3', '.3', '.3', '.3'],
        ['.4', '.4', '.4', '.4', '.4', '.4', '.4', '.4', '.4', '.4'],
        ['.5', '.5', '.5', '.5', '.5', '.5', '.5', '.5', '.5', '.5'],
        ['.6', '.6', '.6', '.6', '.6', '.6', '.6', '.6', '.6', '.6'],
        ['.7', '.7', '.7', '.7', '.7', '.7', '.7', '.7', '.7', '.7'],
        ['.8', '.8', '.8', '.8', '.8', '.8', '.8', '.8', '.8', '.8'],
        ['.9', '.9', '.9', '.9', '.9', '.9', '.9', '.9', '.9', '.9'],
        ['1.5', '1.5', '1.5', '1.5', '1.5', '1.5', '1.5', '1.5', '1.5', '1.5'],
      ],
    },
    div: {
      left: [
        ['.01', '.02', '.03', '.04', '.05', '.06', '.08', '.15', '.2', '.25'],
        ['.02', '.04', '.06', '.08', '.1', '.12', '.16', '.3', '.4', '.5'],
        ['.03', '.06', '.09', '.12', '.15', '.18', '.24', '.45', '.6', '.75'],
        ['.04', '.08', '.12', '.16', '.2', '.24', '.32', '.6', '.8', '1'],
        ['.05', '.1', '.15', '.2', '.25', '.3', '.4', '.75', '1', '1.25'],
        ['.06', '.12', '.18', '.24', '.3', '.36', '.48', '.9', '1.2', '1.5'],
        [
          '.07',
          '.14',
          '.21',
          '.28',
          '.35',
          '.42',
          '.56',
          '1.05',
          '1.4',
          '1.75',
        ],
        ['.08', '.16', '.24', '.32', '.4', '.48', '.64', '1.2', '1.6', '2'],
        [
          '.09',
          '.18',
          '.27',
          '.36',
          '.45',
          '.54',
          '.72',
          '1.35',
          '1.8',
          '2.25',
        ],
        ['.15', '.3', '.45', '.6', '.75', '.9', '1.2', '2.25', '3', '3.75'],
      ],
      right: [
        ['.1', '.2', '.3', '.4', '.5', '.6', '.8', '1.5', '2', '2.5'],
        ['.1', '.2', '.3', '.4', '.5', '.6', '.8', '1.5', '2', '2.5'],
        ['.1', '.2', '.3', '.4', '.5', '.6', '.8', '1.5', '2', '2.5'],
        ['.1', '.2', '.3', '.4', '.5', '.6', '.8', '1.5', '2', '2.5'],
        ['.1', '.2', '.3', '.4', '.5', '.6', '.8', '1.5', '2', '2.5'],
        ['.1', '.2', '.3', '.4', '.5', '.6', '.8', '1.5', '2', '2.5'],
        ['.1', '.2', '.3', '.4', '.5', '.6', '.8', '1.5', '2', '2.5'],
        ['.1', '.2', '.3', '.4', '.5', '.6', '.8', '1.5', '2', '2.5'],
        ['.1', '.2', '.3', '.4', '.5', '.6', '.8', '1.5', '2', '2.5'],
        ['.1', '.2', '.3', '.4', '.5', '.6', '.8', '1.5', '2', '2.5'],
      ],
    },
  },
  int: {
    add: {
      left: [
        ['2', '-3', '2', '-3', '6', '5', '-6', '9', '-10', '11'],
        ['-1', '4', '-1', '-6', '3', '-4', '-9', '10', '7', '-8'],
        ['-4', '5', '6', '1', '-2', '-9', '10', '5', '-6', '7'],
        ['5', '-2', '-7', '-8', '9', '-2', '3', '-12', '13', '14'],
        ['-4', '-7', '-2', '9', '-10', '11', '-2', '3', '-4', '-15'],
        ['-7', '-4', '9', '10', '-1', '-12', '13', '-2', '3', '-16'],
        ['-8', '9', '-10', '-3', '-12', '13', '-14', '15', '2', '17'],
        ['9', '-6', '11', '-12', '-3', '14', '-1', '-16', '17', '2'],
        ['-10', '-11', '12', '-5', '14', '-3', '16', '17', '-18', '-1'],
        ['-9', '12', '-13', '14', '-15', '4', '-17', '-2', '19', '-20'],
      ],
      right: [
        ['-1', '2', '-3', '4', '-5', '-6', '7', '-8', '9', '10'],
        ['-1', '-2', '3', '4', '-5', '6', '7', '-8', '9', '10'],
        ['1', '-2', '-3', '-4', '5', '6', '-7', '-8', '9', '-10'],
        ['-1', '-2', '3', '4', '-5', '6', '-7', '8', '-9', '-10'],
        ['-1', '2', '-3', '-4', '5', '6', '7', '-8', '9', '10'],
        ['1', '-2', '-3', '-4', '-5', '6', '-7', '8', '-9', '10'],
        ['1', '-2', '3', '-4', '5', '-6', '7', '-8', '-9', '-10'],
        ['-1', '-2', '-3', '4', '-5', '-6', '-7', '8', '-9', '-10'],
        ['1', '2', '-3', '-4', '-5', '-6', '-7', '-8', '9', '10'],
        ['-1', '-2', '3', '-4', '5', '6', '7', '-8', '9', '10'],
      ],
    },
    sub: {
      left: [
        ['-2', '3', '4', '-5', '-6', '7', '-8', '9', '10', '-11'],
        ['-1', '4', '-5', '-2', '7', '-4', '9', '-10', '-7', '12'],
        ['2', '-5', '6', '1', '-8', '-3', '10', '5', '6', '-13'],
        ['5', '-2', '-7', '-8', '1', '-2', '-11', '12', '-5', '6'],
        ['6', '3', '8', '-1', '-10', '1', '-2', '-13', '4', '-5'],
        ['5', '4', '-9', '-2', '-1', '12', '1', '-2', '3', '-16'],
        ['-6', '-5', '4', '-11', '12', '-13', '-14', '1', '-2', '3'],
        ['7', '-6', '-5', '4', '-13', '14', '-1', '-16', '1', '-18'],
        ['-10', '7', '-6', '-5', '4', '-15', '16', '1', '-18', '1'],
        ['-9', '-12', '7', '-6', '15', '4', '-17', '-2', '-19', '20'],
      ],
      right: [
        ['-1', '2', '3', '-4', '-5', '6', '-7', '8', '9', '-10'],
        ['1', '2', '-3', '-4', '5', '-6', '7', '-8', '-9', '10'],
        ['-1', '-2', '3', '4', '-5', '-6', '7', '8', '9', '-10'],
        ['1', '2', '-3', '-4', '5', '-6', '-7', '8', '-9', '10'],
        ['1', '-2', '3', '4', '-5', '6', '-7', '-8', '9', '-10'],
        ['-1', '-2', '-3', '4', '5', '6', '7', '-8', '9', '-10'],
        ['1', '2', '-3', '-4', '5', '-6', '-7', '8', '-9', '10'],
        ['-1', '2', '3', '-4', '-5', '6', '7', '-8', '-9', '-10'],
        ['-1', '-2', '3', '4', '-5', '-6', '7', '-8', '-9', '10'],
        ['1', '-2', '-3', '4', '5', '-6', '-7', '8', '-9', '10'],
      ],
    },
    mul: {
      left: [
        ['-1', '-1', '-1', '1', '-1', '1', '-1', '-1', '1', '-1'],
        ['-2', '2', '-2', '-2', '-2', '2', '-2', '2', '-2', '-2'],
        ['-3', '-3', '-3', '-3', '3', '-3', '3', '3', '-3', '3'],
        ['4', '-4', '-4', '-4', '-4', '4', '-4', '4', '-4', '-4'],
        ['-5', '-5', '5', '-5', '-5', '5', '-5', '-5', '5', '-5'],
        ['-6', '6', '-6', '-6', '6', '-6', '-6', '-6', '6', '-6'],
        ['7', '-7', '7', '7', '-7', '-7', '7', '-7', '7', '-7'],
        ['-8', '8', '-8', '8', '-8', '-8', '-8', '-8', '-8', '8'],
        ['9', '-9', '-9', '-9', '9', '-9', '9', '-9', '-9', '-9'],
        ['-10', '10', '10', '-10', '-10', '-10', '10', '10', '-10', '-10'],
      ],
      right: [
        ['-1', '2', '-3', '-4', '5', '-6', '-7', '8', '-9', '10'],
        ['-1', '-2', '3', '-4', '5', '-6', '-7', '-8', '9', '10'],
        ['1', '-2', '-3', '4', '-5', '-6', '-7', '8', '9', '-10'],
        ['-1', '2', '3', '-4', '-5', '-6', '7', '-8', '9', '10'],
        ['1', '2', '-3', '4', '5', '-6', '7', '-8', '-9', '10'],
        ['-1', '-2', '3', '-4', '-5', '-6', '7', '-8', '9', '10'],
        ['-1', '2', '-3', '4', '-5', '6', '-7', '8', '-9', '-10'],
        ['1', '-2', '-3', '-4', '5', '6', '-7', '8', '9', '-10'],
        ['-1', '-2', '3', '-4', '-5', '-6', '-7', '-8', '-9', '10'],
        ['1', '-2', '-3', '4', '5', '6', '-7', '-8', '-9', '-10'],
      ],
    },
    div: {
      left: [
        ['-1', '2', '-3', '4', '-5', '6', '-7', '-8', '-9', '10'],
        ['-2', '-4', '6', '-8', '-10', '-12', '14', '16', '-18', '20'],
        ['-3', '-6', '-9', '-12', '-15', '18', '21', '-24', '-27', '-30'],
        ['4', '8', '-12', '-16', '20', '-24', '28', '-32', '36', '40'],
        ['-5', '-10', '-15', '20', '-25', '30', '-35', '40', '-45', '-50'],
        ['-6', '-12', '18', '24', '-30', '-36', '-42', '48', '-54', '60'],
        ['-7', '14', '21', '28', '-35', '-42', '49', '-56', '63', '-70'],
        ['-8', '-16', '-24', '-32', '40', '48', '-56', '-64', '72', '-80'],
        ['9', '-18', '27', '36', '45', '-54', '63', '-72', '-81', '90'],
        ['-10', '20', '30', '-40', '-50', '-60', '-70', '80', '-90', '100'],
      ],
      right: [
        ['1', '-2', '-3', '-4', '-5', '-6', '7', '-8', '-9', '10'],
        ['1', '-2', '-3', '-4', '5', '-6', '7', '-8', '9', '-10'],
        ['-1', '2', '-3', '4', '-5', '-6', '-7', '-8', '9', '-10'],
        ['-1', '2', '3', '-4', '-5', '-6', '7', '8', '-9', '-10'],
        ['-1', '2', '-3', '-4', '-5', '-6', '7', '8', '-9', '-10'],
        ['1', '-2', '-3', '-4', '5', '-6', '-7', '-8', '9', '-10'],
        ['1', '-2', '3', '-4', '-5', '6', '-7', '-8', '9', '-10'],
        ['-1', '-2', '3', '-4', '-5', '6', '-7', '8', '-9', '10'],
        ['-1', '2', '3', '-4', '5', '6', '-7', '-8', '-9', '-10'],
        ['1', '2', '-3', '-4', '5', '-6', '-7', '-8', '9', '-10'],
      ],
    },
  },
  frc: {
    add: {
      left: [
        ['1/8', '1/4', '1/3', '3/8', '1/2', '5/8', '7/8', '3/4', '5/4', '12/8'],
        ['1/8', '1/4', '1/3', '3/8', '1/2', '5/8', '2/3', '3/4', '5/4', '3/2'],
        [
          '2/12',
          '1/4',
          '1/3',
          '5/12',
          '1/2',
          '5/8',
          '2/3',
          '3/4',
          '15/12',
          '9/6',
        ],
        ['1/8', '1/4', '1/3', '3/8', '1/2', '5/8', '7/8', '3/4', '5/4', '3/2'],
        ['1/8', '1/4', '1/3', '3/8', '1/2', '5/8', '2/3', '3/4', '5/4', '3/2'],
        ['1/8', '1/4', '2/4', '3/8', '1/2', '5/8', '7/8', '3/4', '5/4', '6/4'],
        ['1/8', '1/4', '1/3', '3/8', '1/2', '5/8', '2/3', '4/6', '7/6', '3/2'],
        ['1/8', '1/4', '1/3', '3/8', '1/2', '5/8', '2/3', '3/4', '5/4', '3/2'],
        ['1/8', '1/4', '4/12', '3/8', '1/2', '5/8', '2/3', '3/4', '5/4', '3/2'],
        ['1/8', '1/4', '1/3', '3/8', '1/2', '5/8', '2/3', '3/4', '5/4', '3/2'],
      ],
      right: [
        ['1/8', '1/8', '1/8', '1/8', '1/8', '1/8', '1/8', '1/8', '1/8', '1/8'],
        ['1/4', '1/4', '1/4', '1/4', '2/4', '1/4', '1/4', '1/4', '1/4', '1/4'],
        [
          '3/12',
          '1/3',
          '1/3',
          '4/12',
          '1/3',
          '2/4',
          '1/3',
          '1/3',
          '2/6',
          '1/3',
        ],
        ['3/8', '3/8', '2/6', '3/8', '3/8', '3/8', '3/8', '3/8', '3/8', '3/8'],
        ['1/2', '1/2', '1/2', '1/2', '1/2', '1/2', '1/2', '1/2', '1/2', '1/2'],
        ['5/8', '5/8', '5/8', '5/8', '5/8', '5/8', '5/8', '5/8', '5/8', '5/8'],
        ['7/8', '8/12', '2/3', '7/8', '2/3', '7/8', '2/3', '2/3', '2/3', '4/6'],
        ['3/4', '3/4', '3/4', '3/4', '3/4', '3/4', '3/4', '3/4', '3/4', '3/4'],
        ['5/4', '5/4', '5/4', '5/4', '5/4', '5/4', '5/4', '5/4', '5/4', '5/4'],
        ['3/2', '3/2', '9/6', '3/2', '3/2', '3/2', '3/2', '3/2', '3/2', '3/2'],
      ],
    },
    sub: {
      left: [
        [
          '1/4',
          '3/8',
          '11/24',
          '1/2',
          '5/8',
          '3/4',
          '4/4',
          '7/8',
          '11/8',
          '13/8',
        ],
        ['3/8', '1/2', '7/12', '5/8', '3/4', '7/8', '11/12', '1', '3/2', '7/4'],
        [
          '11/24',
          '7/12',
          '2/3',
          '17/24',
          '5/6',
          '10/12',
          '1',
          '13/12',
          '19/12',
          '11/6',
        ],
        [
          '1/2',
          '5/8',
          '17/24',
          '3/4',
          '7/8',
          '1',
          '5/4',
          '9/8',
          '13/8',
          '15/8',
        ],
        ['5/8', '3/4', '5/6', '7/8', '1', '9/8', '7/6', '5/4', '7/4', '2'],
        ['3/4', '7/8', '9/8', '1', '9/8', '5/4', '3/2', '11/8', '15/8', '17/8'],
        [
          '1',
          '11/12',
          '1',
          '5/4',
          '7/6',
          '3/2',
          '4/3',
          '17/12',
          '23/12',
          '13/6',
        ],
        ['7/8', '1', '13/12', '9/8', '5/4', '11/8', '17/12', '3/2', '2', '9/4'],
        [
          '11/8',
          '3/2',
          '19/12',
          '13/8',
          '7/4',
          '15/8',
          '23/12',
          '2',
          '5/2',
          '11/4',
        ],
        [
          '13/8',
          '7/4',
          '11/6',
          '15/8',
          '2',
          '17/8',
          '13/6',
          '9/4',
          '11/4',
          '3',
        ],
      ],
      right: [
        ['1/8', '1/4', '1/3', '3/8', '1/2', '5/8', '7/8', '3/4', '5/4', '3/2'],
        ['1/8', '1/4', '1/3', '3/8', '1/2', '5/8', '2/3', '3/4', '5/4', '3/2'],
        ['1/8', '1/4', '1/3', '3/8', '1/2', '2/4', '2/3', '3/4', '5/4', '3/2'],
        ['1/8', '1/4', '1/3', '3/8', '1/2', '5/8', '7/8', '3/4', '5/4', '3/2'],
        ['1/8', '1/4', '1/3', '3/8', '1/2', '5/8', '2/3', '3/4', '5/4', '3/2'],
        ['1/8', '1/4', '2/4', '3/8', '1/2', '5/8', '7/8', '3/4', '5/4', '3/2'],
        ['1/8', '1/4', '1/3', '3/8', '1/2', '5/8', '2/3', '3/4', '5/4', '3/2'],
        ['1/8', '1/4', '1/3', '3/8', '1/2', '5/8', '2/3', '3/4', '5/4', '3/2'],
        ['1/8', '1/4', '1/3', '3/8', '1/2', '5/8', '2/3', '3/4', '5/4', '3/2'],
        ['1/8', '1/4', '1/3', '3/8', '1/2', '5/8', '2/3', '3/4', '5/4', '3/2'],
      ],
    },
    mul: {
      left: [
        ['1/8', '1/4', '1/3', '3/8', '1/2', '5/8', '2/3', '3/4', '5/4', '3/2'],
        ['1/8', '1/4', '1/3', '3/8', '1/2', '5/8', '2/3', '3/4', '5/4', '3/2'],
        ['1/8', '1/4', '1/3', '3/8', '1/2', '5/8', '2/3', '3/4', '5/4', '3/2'],
        ['1/8', '1/4', '1/3', '3/8', '1/2', '5/8', '2/3', '3/4', '5/4', '3/2'],
        ['1/8', '1/4', '1/3', '3/8', '1/2', '5/8', '2/3', '3/4', '5/4', '3/2'],
        ['1/8', '1/4', '1/3', '3/8', '1/2', '5/8', '2/3', '3/4', '5/4', '3/2'],
        ['1/8', '1/4', '1/3', '3/8', '1/2', '5/8', '2/3', '3/4', '5/4', '3/2'],
        ['1/8', '1/4', '1/3', '3/8', '1/2', '5/8', '2/3', '3/4', '5/4', '3/2'],
        ['1/8', '1/4', '1/3', '3/8', '1/2', '5/8', '2/3', '3/4', '5/4', '3/2'],
        ['1/8', '1/4', '1/3', '3/8', '1/2', '5/8', '2/3', '3/4', '5/4', '3/2'],
      ],
      right: [
        ['1/8', '1/8', '1/8', '1/8', '1/8', '1/8', '1/8', '1/8', '1/8', '1/8'],
        ['1/4', '1/4', '1/4', '1/4', '1/4', '1/4', '1/4', '1/4', '1/4', '1/4'],
        ['1/3', '1/3', '1/3', '1/3', '1/3', '1/3', '1/3', '1/3', '1/3', '1/3'],
        ['3/8', '3/8', '3/8', '3/8', '3/8', '3/8', '3/8', '3/8', '3/8', '3/8'],
        ['1/2', '1/2', '1/2', '1/2', '1/2', '1/2', '1/2', '1/2', '1/2', '1/2'],
        ['5/8', '5/8', '5/8', '5/8', '5/8', '5/8', '5/8', '5/8', '5/8', '5/8'],
        ['2/3', '2/3', '2/3', '2/3', '2/3', '2/3', '2/3', '2/3', '2/3', '2/3'],
        ['3/4', '3/4', '3/4', '3/4', '3/4', '3/4', '3/4', '3/4', '3/4', '3/4'],
        ['5/4', '5/4', '5/4', '5/4', '5/4', '5/4', '5/4', '5/4', '5/4', '5/4'],
        ['3/2', '3/2', '3/2', '3/2', '3/2', '3/2', '3/2', '3/2', '3/2', '3/2'],
      ],
    },
    div: {
      left: [
        ['1/8', '1/4', '1/3', '3/8', '1/2', '5/8', '2/3', '3/4', '5/4', '3/2'],
        ['1/8', '1/4', '1/3', '3/8', '1/2', '5/8', '2/3', '3/4', '5/4', '3/2'],
        ['1/8', '1/4', '1/3', '3/8', '1/2', '5/8', '2/3', '3/4', '5/4', '3/2'],
        ['1/8', '1/4', '1/3', '3/8', '1/2', '5/8', '2/3', '3/4', '5/4', '3/2'],
        ['1/8', '1/4', '1/3', '3/8', '1/2', '5/8', '2/3', '3/4', '5/4', '3/2'],
        ['1/8', '1/4', '1/3', '3/8', '1/2', '5/8', '2/3', '3/4', '5/4', '3/2'],
        ['1/8', '1/4', '1/3', '3/8', '1/2', '5/8', '2/3', '3/4', '5/4', '3/2'],
        ['1/8', '1/4', '1/3', '3/8', '1/2', '5/8', '2/3', '3/4', '5/4', '3/2'],
        ['1/8', '1/4', '1/3', '3/8', '1/2', '5/8', '2/3', '3/4', '5/4', '3/2'],
        ['1/8', '1/4', '1/3', '3/8', '1/2', '5/8', '2/3', '3/4', '5/4', '3/2'],
      ],
      right: [
        ['1/8', '1/8', '1/8', '1/8', '1/8', '1/8', '1/8', '1/8', '1/8', '1/8'],
        ['1/4', '1/4', '1/4', '1/4', '1/4', '1/4', '1/4', '1/4', '1/4', '1/4'],
        ['1/3', '1/3', '1/3', '1/3', '1/3', '1/3', '1/3', '1/3', '1/3', '1/3'],
        ['3/8', '3/8', '3/8', '3/8', '3/8', '3/8', '3/8', '3/8', '3/8', '3/8'],
        ['1/2', '1/2', '1/2', '1/2', '1/2', '1/2', '1/2', '1/2', '1/2', '1/2'],
        ['5/8', '5/8', '5/8', '5/8', '5/8', '5/8', '5/8', '5/8', '5/8', '5/8'],
        ['2/3', '2/3', '2/3', '2/3', '2/3', '2/3', '2/3', '2/3', '2/3', '2/3'],
        ['3/4', '3/4', '3/4', '3/4', '3/4', '3/4', '3/4', '3/4', '3/4', '3/4'],
        ['5/4', '5/4', '5/4', '5/4', '5/4', '5/4', '5/4', '5/4', '5/4', '5/4'],
        ['3/2', '3/2', '3/2', '3/2', '3/2', '3/2', '3/2', '3/2', '3/2', '3/2'],
      ],
    },
  },
};
